"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DRAFT"] = "DRAFT";
    OrderStatus["CREATED"] = "CREATED";
    OrderStatus["ARCHIVED"] = "ARCHIVED";
    OrderStatus["SCHEDULED"] = "SCHEDULED";
    OrderStatus["SUBMITTED"] = "SUBMITTED";
    OrderStatus["PROCESSING"] = "PROCESSING";
    OrderStatus["READY_TO_SHIP"] = "READY_TO_SHIP";
    OrderStatus["SHIPPED"] = "SHIPPED";
    OrderStatus["DELIVERED"] = "DELIVERED";
    OrderStatus["ARRIVED"] = "ARRIVED";
    OrderStatus["RECEIVING"] = "RECEIVING";
    OrderStatus["COMPLETED"] = "COMPLETED";
    OrderStatus["CANCELLED"] = "CANCELLED";
    // this is added to have same state as shipment
    // this will be triggered if any of the shipment has error
    OrderStatus["ERROR"] = "ERROR";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
//# sourceMappingURL=OrderResponse.js.map